import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestLimiteAbastecimento({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'limiteabastecimento', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteLimiteAbastecimento({ payload }) {
  try {
    const { idarqueacao, params } = payload;

    yield call(api.delete, `arqueacoes/${idarqueacao}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { arqueacao, params } = payload;

    yield call(api.post, 'limiteabastecimento', arqueacao);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/arqueacao');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;

    const { data } = yield call(api.get, `limiteabastecimento/${id}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { limiteAbastecimento, params } = payload;

    yield call(api.put, 'limiteabastecimento', limiteAbastecimento);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/cadlimit_abastecim');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'limiteabastecimento', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest('@limiteabastecimento/LIMITEABASTECIMENTO_IN_REQUEST', requestLimiteAbastecimento),
  takeLatest('@limiteabastecimento/DELETE_LIMITEABASTECIMENTO', deleteLimiteAbastecimento),
  takeLatest('@limiteabastecimento/SUCCESS_REMOVE', requestLimiteAbastecimento),
  takeLatest('@limiteabastecimento/STORE_LIMITEABASTECIMENTO', store),
  takeLatest('@limiteabastecimento/FIND_LIMITEABASTECIMENTO', find),
  takeLatest('@limiteabastecimento/UPDATE_LIMITEABASTECIMENTO', update),
  takeLatest('@limiteabastecimento/RECORD_FILTERING', applyedFilters),
]);
